<template>
  <div class="customer-property-display-component">
    <table class="table table-fixed table-striped table-bordered">
      <tbody>
      <tr>
        <th colspan="4">
          Klantadres
        </th>
      </tr>
      <tr v-if="propertyOccupancyType === 'rental'">
        <th>Contract staat op naam van</th>
        <td v-if="isMainCustomer && customerProperty.contract_owner === 'main_customer'">{{ customerName }}</td>
        <td v-if="!isMainCustomer && customerProperty.contract_owner === 'main_customer'">{{ partnerName }}</td>
        <td v-if="isMainCustomer && customerProperty.contract_owner === 'partner'">{{ partnerName }}</td>
        <td v-if="!isMainCustomer && customerProperty.contract_owner === 'partner'">{{ customerName }}</td>
        <td v-if="customerProperty.contract_owner === 'both'">{{ customerName }} & {{ partnerName }}</td>
        <td v-if="customerProperty.contract_owner === 'other'">Anders</td>
      </tr>
      <tr>
      <th>Deel {{ customerName }}</th>
        <td>{{ ownerPercentage, 0 | toPercentage }}</td>
        <th>Deel {{ partnerName }}</th>
        <td>{{ partnerOwnerPercentage, 0 | toPercentage }}</td>
      </tr>
      <tr v-if="restPercentage > 0">
        <th>Deel derden</th>
        <td>{{ restPercentage, 0 | toPercentage }}</td>
      </tr>
      <tr v-if="hasPartner && percentageOver100">
        <a-alert :message="' Controleer de eigendomspercentages. Het totaal is nu ' + totalPercentage + '%'"
                 banner type="warning"/>
      </tr>
      <tr>
        <th>Registratiedatum</th>
        <td>
          {{ customerProperty.registration_date | toDate }}
        </td>
        <th>Gemeentelijke registratiedatum</th>
        <td>
          {{ customerProperty.municipality_registration_date | toDate }}
        </td>
      </tr>
      <tr>
        <th>Transactiedatum</th>
        <td>
          {{ customerProperty.transaction_date | toDate }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import customerApi from "~/api/customer"

export default {
  name: "CustomerPropertyShowComponent",
  props: {
    customerProperty: {
      required: true,
    },
    autoSave: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    withAddressType: {
      type: Boolean,
      required: false,
      default: true
    },
    propertyOccupancyType: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      address_type: {
        mail: 'Postadres',
        visit: 'Bezoekadres',
        establishment: 'Vestiging',
      },
      partnerData: null,
      customer: null,
    };
  },
  computed: {
    isMainCustomer() {
      if (this.customer !== null && typeof this.customer !== 'undefined') {
        return this.customer.is_main_customer
      }
    },
    hasPartner() {
      return this.partnerData !== null;
    },
    partnerName() {
      if (this.partnerData !== null && typeof this.hasPartner !== 'undefined') {
        return this.partnerData.full_name ? this.partnerData.full_name : 'Partner';
      }
      return 'Derden'
    },
    customerName() {
      if (this.customer !== null && typeof this.customer !== 'undefined') {
        return this.customer.full_name ? this.customer.full_name : 'Klant';
      }
      return 'Klant'
    },
    ownerPercentage() {
        return this.customerProperty.percentage_owner
    },
    partnerOwnerPercentage() {
      if (!this.hasPartner) {
        return 100 - this.ownerPercentage
      }
      return this.partnerData.current_visit_customer_property.data.percentage_owner;
    },
    totalPercentage() {
      let percentage = 0;
      if (this.ownerPercentage) {
        percentage += this.ownerPercentage
      }
      if (this.partnerOwnerPercentage) {
        percentage += this.partnerOwnerPercentage
      }

      return percentage;
    },
    percentageOver100() {
      return this.totalPercentage > 100
    },
    percentageUnder100() {
      return this.totalPercentage < 100
    },
    restPercentage() {
      return 100 - this.totalPercentage
    }
  },
  mounted() {
    if (this.customerProperty !== null && typeof this.customerProperty !== 'undefined' && this.customerProperty.living_together) {
      customerApi.find(this.customerProperty.customer_id).then(response => {
        this.customer = response.data
      }).catch()
      customerApi.findPartnerByCustomerId(this.customerProperty.customer_id, ['current_visit_customer_property']).then(response => {
        this.partnerData = response.data
      }).catch()
    }
  },
  methods: {}
}
</script>
<style scoped>
.search-component {
  position: relative;
}

.search-component .results {
  position: absolute;
  width: calc(100% - 10px);
  background: rgba(255, 255, 255, 0.91);
  margin: 5px;
  max-height: 300px;
  overflow: auto;
}
</style>
